module.exports = __webpack_public_path__ + "img/6@2x.708aba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/6@2x.png
// module id = uJ2H
// module chunks = 0